import {
  IMaterialsAPI,
  MaterialsOperations,
} from '../../../controllers/MaterialsController'
import { OnRequestChangeCallback } from '../BaseAPI'
import {
  AddKeywordsToPartsArgs,
  KeywordGroupDto,
  MaterialsAndStandardsDto,
  MaterialSelectorDto,
  StandardKeywordDto,
} from './internal-api.contracts'
import { InternalAPI } from './InternalAPI'

export class MaterialsAPI extends InternalAPI implements IMaterialsAPI {
  constructor(
    organizationId,
    private onRequestChange: OnRequestChangeCallback
  ) {
    super()
    this.baseAddress += `/api/parties/${organizationId}`
  }

  public async GetMaterialsAsync(filterTokens: string[]) {
    return await this.GetAsync<MaterialSelectorDto>({
      relativePath: '/materials',
      params: {
        selectedTokens: filterTokens,
      },
      onRequestChange: (req) => {
        this.onRequestChange({
          ...req,
          id: MaterialsOperations.GetMaterials,
        })
      },
    })
  }

  public async GetStandardsAndMaterials() {
    return await this.GetAsync<MaterialsAndStandardsDto[]>({
      relativePath: '/settings/articles/standardsandmaterials',
      onRequestChange: (req) => {
        this.onRequestChange({
          ...req,
          id: MaterialsOperations.GetStandardsAndMaterials,
        })
      },
    })
  }

  public async SaveKeyword(keywords: StandardKeywordDto[]) {
    return await this.PutAsync<MaterialsAndStandardsDto[]>({
      relativePath: '/settings/articles/standardsandmaterials',
      data: keywords,
      onRequestChange: (req) => {
        this.onRequestChange({
          ...req,
          id: keywords[0].name,
        })
      },
    })
  }

  public async AddKeywordsToParts(
    projectId: string,
    args: AddKeywordsToPartsArgs
  ) {
    return await this.PostAsync<void>({
      id: 'AddKeywordsToRows',
      relativePath: `/projects/${projectId}/materials/AddKeywordsToParts`,
      data: args,
      onRequestChange: this.onRequestChange,
    })
  }

  public async GetSelectableKeywordsForAssembly(
    projectId: string,
    assemblyId: string,
    selectedKeywords: string[]
  ) {
    return await this.GetAsync<KeywordGroupDto>({
      id: 'GetSelectableKeywordsForAssembly',
      relativePath: `/projects/${projectId}/materials/GetSelectableKeywordsForAssembly`,
      params: {
        assemblyId,
        selectedTokens: selectedKeywords,
      },
      onRequestChange: this.onRequestChange,
    })
  }
}
